import React from 'react';
import { EventHubSubdomainFormVM } from './event-hub-subdomain-form.viewmodel';
import { EventHubSubdomainFormPresentation } from './event-hub-subdomain-form.presentation';
import { IEventHubDTO } from '../../../../../api/event-hubs.dao';

type EventHubSubdomainFormProps = {
    accountId: number;
    eventHub: IEventHubDTO;
    saveCompletedCallback: (eventHub: IEventHubDTO) => void;
    isOpen: boolean;
    onRequestClose: () => void;
};

export const EventHubSubdomainForm: React.FC<EventHubSubdomainFormProps> = props => {
    const { accountId, eventHub, saveCompletedCallback, isOpen, onRequestClose } = props;

    const vm = React.useMemo(() => {
        if (!isOpen) return null;
        const newVm = new EventHubSubdomainFormVM(accountId, eventHub, saveCompletedCallback);
        newVm.initialize();
        return newVm;
    }, [isOpen, accountId, eventHub, saveCompletedCallback]);

    if (!vm) return null;

    return (
        <EventHubSubdomainFormPresentation
            vm={vm}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
        />
    );
};